import { network } from 'services/network';

export const resetConfigOfSingleChecker = (params) => {
    return network.post('api/bo/resetConfigOfSingleChecker', params).then((response) => {
        return response.data;
    });
};
